import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type NotificationSeverity = "success" | "error" | "info" | "warning";

interface GlobalNotificationState {
  open: boolean;
  message: string;
  severity: NotificationSeverity;
  autoHideDuration: number;
}

const initialState: GlobalNotificationState = {
  open: false,
  message: "",
  severity: "info",
  autoHideDuration: 4000,
};

const globalNotificationSlice = createSlice({
  name: "globalNotification",
  initialState,
  reducers: {
    showNotification: (
      state,
      action: PayloadAction<{
        message: string;
        severity?: NotificationSeverity;
        autoHideDuration?: number;
      }>
    ) => {
      state.open = true;
      state.message = action.payload.message;
      state.severity = action.payload.severity ?? "info";
      state.autoHideDuration = action.payload.autoHideDuration ?? 4000;
    },
    hideNotification: (state) => {
      state.open = false;
    },
  },
});

export const { showNotification, hideNotification } =
  globalNotificationSlice.actions;
export default globalNotificationSlice.reducer;
